import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { verifyToken, loadSession } from 'auth/actions';
import { getIsAuthenticated, getToken } from 'auth/selectors';

const withTokenVerified = (WrappedComponent, authenticated = true) => {
  class TokenVerified extends Component {
    componentWillMount = () => {
      this.props.loadSession();
      if (this.props.token) {
        this.props.verifyToken(this.props.token);
      }
    };

    componentWillReceiveProps = (nextProps) => {
      if (nextProps.token && this.props.token !== nextProps.token) {
        this.props.verifyToken(nextProps.token);
      }
    };

    render = () => {
      return this.props.isAuthenticated ? (
        <WrappedComponent />
      ) : (
        <Redirect to={`/auth/login?next=${this.props.location.pathname}`} />
      );
    };
  }

  const mapStateToProps = (state) => ({
    isAuthenticated: getIsAuthenticated(state),
    token: getToken(state),
  });

  const mapDispatchToProps = { loadSession, verifyToken };

  return connect(mapStateToProps, mapDispatchToProps)(TokenVerified);
};

export default withTokenVerified;



// WEBPACK FOOTER //
// src/modules/secured/hocs/withTokenVerified.js